const ErrorMessageArray = (error, param) => {
  if (error instanceof Array) {
    return error?.map((err) => {
      if (err.param === param) {
        return (
          <span
            key={err.param}
            className="notolao"
            style={{ color: "red", float: "right" }}
          >
            {err.msg}
          </span>
        );
      }
    });
  }
};

export default ErrorMessageArray;
